import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-endpoint",
  "use": "icon-endpoint-usage",
  "viewBox": "0 0 1228 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1228 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-endpoint\"><path d=\"M972.8 563.2H0V460.8h972.8v102.4z\" /><path d=\"M921.6 512a204.8 153.6 90 10307.2 0 204.8 153.6 90 10-307.2 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol